export const capitalize = (s: string) => {
  if (s.length <= 1) {
    return s.toUpperCase();
  }

  return s.substring(0, 1).toUpperCase() + s.slice(1).toLowerCase();
};
